module.exports = __webpack_public_path__ + "static/media/icon-button-arrow-gray-right.c04651fc.svg";